import { PastBookingsData } from 'AppClient/api/Bookings';
import { TableBuilderColumnProps } from 'components/TableBuilder/TableBuilder';

export enum ColumnType {
	JOB_ID = 'jobId',
	PICK_UP_TIME = 'pickUpTime',
	PICK_UP_ADDRESS = 'pickUpAddress',
	DROP_OFF_ADDRESS = 'dropOffAddress',
	SERVICE_PARTNER_NAME = 'servicePartnerName',
	SERVICE_PARTNER_PHONE = 'servicePartnerPhone',
	NUMBER_OF_PASSENGERS = 'numberOfPassengers',
	TRAVEL_SUMMARY = 'travelSummary',
	BOOK_AGAIN = 'bookAgain',
	TOTAL_PRICE = 'totalPrice',
	RATING = 'rating',
}

const columns: Array<TableBuilderColumnProps<PastBookingsData>> = [
	{
		titleText: 'Job ID',
		dataIndex: 'bookingNumber',
		key: ColumnType.JOB_ID,
		width: '5.60%',
		searchParam: 'BookingNumberSearch',
		orderColumn: 'BookingNumber',
		shortSearchText: true,
		sorter: true,
	},
	{
		titleText: 'Pickup time',
		width: '6.91%',
		dataIndex: 'pickUpDateTime',
		key: ColumnType.PICK_UP_TIME,
		orderColumn: 'PickUpDateTime',
		sorter: true,
	},
	{
		titleText: 'Pick up address',
		dataIndex: 'pickUpAddress',
		key: ColumnType.PICK_UP_ADDRESS,
		width: '13.51%',
		searchParam: 'PickUpAddressSearch',
		orderColumn: 'PickUpAddress',
		sorter: true,
	},
	{
		titleText: 'Drop off address',
		width: '13.51%',
		dataIndex: 'dropOffAddress',
		key: ColumnType.DROP_OFF_ADDRESS,
		searchParam: 'DropOffAddressSearch',
		orderColumn: 'DropOffAddress',
		sorter: true,
	},
	{
		titleText: '# of pass',
		width: '5.22%',
		dataIndex: 'numberOfPassengers',
		key: ColumnType.NUMBER_OF_PASSENGERS,
		orderColumn: 'NumberOfPassengers',
		align: 'right',
		isNumberValue: true,
		sorter: true,
	},
	{
		titleText: 'Service partner name',
		dataIndex: 'servicePartnerName',
		key: ColumnType.SERVICE_PARTNER_NAME,
		searchParam: 'ServicePartnerNameSearch',
		orderColumn: 'ServicePartnerName',
		sorter: true,
	},
	{
		titleText: 'Service partner phone',
		dataIndex: 'servicePartnerMainPhoneNumber',
		key: ColumnType.SERVICE_PARTNER_PHONE,
		searchParam: 'ServicePartnerMainPhoneNumberSearch',
		orderColumn: 'ServicePartnerMainPhoneNumber',
		width: '9.98%',
		sorter: true,
	},
	{
		titleText: 'Total price',
		width: '5.83%',
		dataIndex: 'totalPriceInCustomerCurrency',
		key: ColumnType.TOTAL_PRICE,
		orderColumn: 'TotalPriceInCustomerCurrency',
		align: 'right',
		isNumberValue: true,
		sorter: true,
	},
	{
		titleText: 'Travel summary',
		width: '8.29%',
		key: ColumnType.TRAVEL_SUMMARY,
	},
	{
		key: ColumnType.RATING,
		width: '138px',
		fixed: 'right',
		align: 'right',
	},
	{
		key: ColumnType.BOOK_AGAIN,
		width: '92px',
		fixed: 'right',
	},
];

export default columns;
